"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Category = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M16.5,12 C18.4329966,12 20,13.5670034 20,15.5 C20,17.4329966 18.4329966,19 16.5,19 C14.5670034,19 13,17.4329966 13,15.5 C13,13.5670034 14.5670034,12 16.5,12 Z M16.5,13 C15.1192881,13 14,14.1192881 14,15.5 C14,16.8807119 15.1192881,18 16.5,18 C17.8807119,18 19,16.8807119 19,15.5 C19,14.1192881 17.8807119,13 16.5,13 Z M6,12 L11,12 C11.5522847,12 12,12.4477153 12,13 L12,18 C12,18.5522847 11.5522847,19 11,19 L6,19 C5.44771525,19 5,18.5522847 5,18 L5,13 C5,12.4477153 5.44771525,12 6,12 Z M6,13 L6,18 L11,18 L11,13 L6,13 Z M12.9160251,4.2226499 L16.9160251,10.2226499 C17.0692014,10.4524142 17.0071144,10.7628489 16.7773501,10.9160251 C16.6952163,10.970781 16.5987125,11 16.5,11 L8.5,11 C8.22385763,11 8,10.7761424 8,10.5 C8,10.4012875 8.02921901,10.3047837 8.08397485,10.2226499 L12.0839749,4.2226499 C12.2371511,3.99288556 12.5475858,3.93079862 12.7773501,4.08397485 C12.8322762,4.12059228 12.8794077,4.16772376 12.9160251,4.2226499 Z M9.43425855,10 L15.5657415,10 L12.5,5.40138782 L9.43425855,10 Z" })));
};
Category.displayName = 'Category';
exports.default = Category;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Category.js.map